// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let UTCDate = require("../reason/common/types/UTCDate.bs.js");
let TemporalPolyfill = require("temporal-polyfill");

function fromInt(prim) {
  return prim;
}

let PriceInput = {
  fromInt: fromInt
};

let regex = /^\d{4}-(0[1-9]|1[0-2])$/;

function parse(value) {
  return value;
}

function serialize(value) {
  return value;
}

function validate(value) {
  if (regex.test(value)) {
    return {
      TAG: "Ok",
      _0: value
    };
  } else {
    return {
      TAG: "Error",
      _0: "InvalidMonthYearFormat"
    };
  }
}

function monthName(month) {
  switch (month) {
    case "01" :
      return "January";
    case "02" :
      return "February";
    case "03" :
      return "March";
    case "04" :
      return "April";
    case "05" :
      return "May";
    case "06" :
      return "June";
    case "07" :
      return "July";
    case "08" :
      return "August";
    case "09" :
      return "September";
    case "10" :
      return "October";
    case "11" :
      return "November";
    case "12" :
      return "December";
    default:
      return;
  }
}

function toDisplayString(value) {
  let match = value.split("-");
  if (match.length !== 2) {
    return value;
  }
  let year = match[0];
  let month = match[1];
  let month$1 = monthName(month);
  if (month$1 !== undefined) {
    return month$1 + ` ` + year;
  } else {
    return value;
  }
}

let MonthYear = {
  parse: parse,
  serialize: serialize,
  validate: validate,
  toDisplayString: toDisplayString
};

function fromJsDate(prim) {
  return prim.toISOString();
}

let DateTime = {
  toUTC: UTCDate.fromString,
  fromJsDate: fromJsDate
};

let emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

function validate$1(v) {
  if (emailRegex.test(v)) {
    return {
      TAG: "Ok",
      _0: v
    };
  } else {
    return {
      TAG: "Error",
      _0: "InvalidEmailAddress"
    };
  }
}

function toString(v) {
  return v;
}

let EmailAddress = {
  validate: validate$1,
  toString: toString
};

let JSONObject = {};

function toWebapiUrl(t) {
  return new URL(t);
}

function toString$1(v) {
  return v;
}

function fromString(v) {
  let rawUrl = v.startsWith("http://") || v.startsWith("https://") ? v : "https://" + v;
  let urlRegex = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
  if (urlRegex.test(rawUrl)) {
    return {
      TAG: "Ok",
      _0: rawUrl
    };
  } else {
    return {
      TAG: "Error",
      _0: "InvalidURL"
    };
  }
}

let HTML = {};

function parse$1(prim) {
  return TemporalPolyfill.Temporal.PlainDateTime.from(prim);
}

function serialize$1(prim) {
  return prim.toString();
}

let PlainDateTime = {
  parse: parse$1,
  serialize: serialize$1
};

let CalendarDate;

let URL$1 = {
  toString: toString$1,
  toWebapiUrl: toWebapiUrl,
  fromString: fromString
};

exports.PriceInput = PriceInput;
exports.CalendarDate = CalendarDate;
exports.MonthYear = MonthYear;
exports.DateTime = DateTime;
exports.EmailAddress = EmailAddress;
exports.JSONObject = JSONObject;
exports.URL = URL$1;
exports.HTML = HTML;
exports.PlainDateTime = PlainDateTime;
/* UTCDate Not a pure module */
